/**
 * 判断是否为有限数
 * @return {Boolean}
 */
import isNumber from './is-number';
export default function (value) {
    return isNumber(value) && isFinite(value);
}
//# sourceMappingURL=is-finite.js.map